import React, { useState } from 'react';
import { Container, Form, Checkbox, Header, Icon, Breadcrumb, Button, Grid, Dropdown, Radio, InputOnChangeData, DropdownItemProps, DropdownProps } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useHistory, useLocation } from 'react-router';
import { useProviderForm } from './useProviderForm';

export function CreateProvider() {

    let [values,masterData, errors, touched, isLoading, isSubmitting, isValid,errorMessage, registerRef, handleChange, handleBlur, handleSubmit] = useProviderForm(true);

    const history = useHistory();

    return <Container className='providers-container'>
        <Header as='h1' style={{ marginTop: '2.0rem', marginBottom: '0.5rem' }}>Create Provider</Header>
        <hr style={{ marginBottom: '1.0rem' }} />
        <Breadcrumb style={{ marginBottom: '1.0rem' }}>
            <Breadcrumb.Section link><Link to='/dashboard'>Home</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section link><Link to={'/providers'}>Providers</Link></Breadcrumb.Section>
            <Breadcrumb.Divider />
            <Breadcrumb.Section active>Create Provider</Breadcrumb.Section>
        </Breadcrumb>
        <Grid columns={2}>
            <Grid.Column>
                <Form loading={isLoading || !masterData}>
                    <Form.Field required error={!(!errors.categoryId || !touched.categoryId) ? true : false}
                        className={!(!errors.categoryId || !touched.categoryId) ? 'mb-0':''}
                    >
                        <label>Category</label>
                        <Dropdown
                            placeholder='Select Category'
                            fluid
                            selection
                            value={values.categoryId}
                            options={ (masterData?.providerCategorys) || []}
                            onChange={(event, data)=>{
                                handleChange(data.value, 'categoryId');
                            }}
                            error={!(!errors.categoryId || !touched.categoryId) ? true : false}
                        />
                    </Form.Field>
                    {
                        !(!errors.categoryId || !touched.categoryId) &&
                        <div className='error-message'><Icon name='warning sign' color='orange'/> {errors.categoryId}</div>
                    }
                    <Form.Input
                        className={!(!errors.providerName || !touched.providerName) ? 'mb-0':''}
                        required
                        fluid
                        label='Provider Name'
                        value={values.providerName}
                        onChange={(event, data) => {
                            handleChange(data.value, 'providerName');
                        }}
                        onBlur={
                            () => {handleBlur('providerName'); }
                        }
                        error={!(!errors.providerName || !touched.providerName) ? true : false}
                    />
                    {
                        !(!errors.providerName || !touched.providerName) &&
                        <div className='error-message'><Icon name='warning sign' color='orange'/> {errors.providerName}</div>
                    }
                    <Form.Input className={!(!errors.websiteURL || !touched.websiteURL) ? 'mb-0':''}
                        
                        fluid
                        label='Website URL'
                        value={values.websiteURL}
                        onChange={(event, data) => {
                            handleChange(data.value, 'websiteURL');
                        }}
                        onBlur={
                            () => {handleBlur('websiteURL'); }
                        }
                        error={!(!errors.websiteURL || !touched.websiteURL) ? true : false}
                    
                    />
                    {
                        !(!errors.websiteURL || !touched.websiteURL) &&
                        <div className='error-message'><Icon name='warning sign' color='orange'/> {errors.websiteURL}</div>
                    }
                    <Form.Group inline className={!(!errors.providerTypeId || !touched.providerTypeId) ? 'mb-0':''}>
                        <label>Provider Type<span style={{color:'#db2828', margin:'-0.2em 0 0 0.2em'}}>*</span></label>
                        {
                            masterData && masterData.providerTypes.map((item: DropdownItemProps, index: number)=>{
                                return (<Form.Field
                                    key={index}
                                    control={Radio}
                                    label={item.text}
                                    value={item.value}
                                    checked={values.providerTypeId === item.value}
                                    onChange={(event: any, data:any)=>{
                                        let newValue = (data as {value: any}).value;
                                        handleChange(newValue, 'providerTypeId');
                                    }}
                                    error={!(!errors.providerTypeId || !touched.providerTypeId) ? true : false}
                                />);
                            })
                        }
                    </Form.Group>
                    {
                        !(!errors.providerTypeId || !touched.providerTypeId) &&
                        <div className='error-message'><Icon name='warning sign' color='orange'/> {errors.providerTypeId}</div>
                    }
                    <Form.Field required 
                        error={!(!errors.credentialIds || !touched.credentialIds) ? true : false}
                        className={!(!errors.credentialIds || !touched.credentialIds) ? 'mb-0':''}>
                        <label>Credential</label>
                        <Dropdown
                            placeholder='Select Credential'
                            fluid
                            multiple
                            selection
                            closeOnChange={true}
                            clearable
                            value={values.credentialIds}
                            options={(masterData?.providerCredentials) || []}
                            onChange={(event, data)=>{
                                handleChange(data.value, 'credentialIds');
                            }}
                            onClose = {
                                ()=>{handleBlur('credentialIds')}
                            }
                            error={!(!errors.credentialIds || !touched.credentialIds) ? true : false}
                        />
                    </Form.Field>
                    {
                        !(!errors.credentialIds || !touched.credentialIds) &&
                        <div className='error-message'><Icon name='warning sign' color='orange'/> {errors.credentialIds}</div>
                    }
                    <Form.Field required 
                        error={!(!errors.trainingOfferIds || !touched.trainingOfferIds) ? true : false}
                        className={!(!errors.trainingOfferIds || !touched.trainingOfferIds) ? 'mb-0':''}>
                        <label>Training Offered</label>
                        <Dropdown
                            placeholder='Select Training Offered'
                            fluid
                            multiple
                            search
                            clearable
                            closeOnChange={true}
                            selection
                            options={(masterData?.providerTranings) || []}
                            onChange={(event, data)=>{
                                let newValue = (data as {value: any}).value;
                                handleChange(newValue, 'trainingOfferIds');
                            }}
                            onClose = {
                                ()=>{handleBlur('trainingOfferIds')}
                            }
                            error={!(!errors.trainingOfferIds || !touched.trainingOfferIds) ? true : false}
                        />
                    </Form.Field>
                    {
                        !(!errors.trainingOfferIds || !touched.trainingOfferIds) &&
                        <div className='error-message'><Icon name='warning sign' color='orange'/> {errors.trainingOfferIds}</div>
                    }
                    <Form.Input className={!(!errors.providerAddress || !touched.providerAddress) ? 'mb-0':''}
                        
                        fluid
                        label='Address'
                        onChange={(event, data) => {
                            handleChange(data.value, 'providerAddress');
                        }}
                        onBlur={
                            () => { handleBlur('providerAddress') }
                        }
                        error={!(!errors.providerAddress || !touched.providerAddress) ? true : false}
                    />
                    {
                        !(!errors.providerAddress || !touched.providerAddress) &&
                        <div className='error-message'><Icon name='warning sign' color='orange'/> {errors.providerAddress}</div>
                    }
                    <Form.Input className={!(!errors.providerContact || !touched.providerContact) ? 'mb-0':''}
                        
                        fluid
                        label='Contact Person Full Name'
                        onChange={(event, data) => {
                            handleChange(data.value, 'providerContact');
                        }}
                        onBlur={
                            () => { handleBlur('providerContact') }
                        }
                        error={!(!errors.providerContact || !touched.providerContact) ? true : false}
                    />
                    {
                        !(!errors.providerContact || !touched.providerContact) &&
                        <div className='error-message'><Icon name='warning sign' color='orange'/> {errors.providerContact}</div>
                    }
                    <Form.Input className={!(!errors.providerPhone || !touched.providerPhone) ? 'mb-0':''}
                        
                        fluid
                        label='Phone'
                        value={values.providerPhone}
                        onChange={(event, data) => {
                            handleChange(data.value, 'providerPhone');
                        }}
                        onBlur={
                            () => { handleBlur('providerPhone') }
                        }
                        error={!(!errors.providerPhone || !touched.providerPhone) ? true : false}
                    />
                    {
                        !(!errors.providerPhone || !touched.providerPhone) &&
                        <div className='error-message'><Icon name='warning sign' color='orange'/> {errors.providerPhone}</div>
                    }
                    <Form.Input className={!(!errors.providerEmail || !touched.providerEmail) ? 'mb-0':''}
                        
                        fluid
                        label='Email Address'
                        onChange={(event, data) => {
                            handleChange(data.value, 'providerEmail');
                        }}
                        onBlur={
                            () => { handleBlur('providerEmail') }
                        }
                        error={!(!errors.providerEmail || !touched.providerEmail) ? true : false}
                    />
                    {
                        !(!errors.providerEmail || !touched.providerEmail) &&
                        <div className='error-message'><Icon name='warning sign' color='orange'/> {errors.providerEmail}</div>
                    }

                    <Button type='button' primary onClick={handleSubmit}>Create</Button>
                    <Button type='button' onClick={()=>{history.goBack()}}>Cancel</Button>
                </Form>
            </Grid.Column>
        </Grid>

    </Container>
}